// extracted by mini-css-extract-plugin
export default {"lowPlannerSupply":"lowPlannerSupply__ZjkyM","hed":"hed__MmI1N"};